import { useContext } from 'react';
import { GradebookAppContext } from "./GradebookAppContext.js";
export var useGradebookApp = function useGradebookApp() {
  var context = useContext(GradebookAppContext);
  if (!context) {
    throw new Error('useGradebookApp must be used within GradebookAppProvider');
  }
  return context;
};